import { getIsAcceleratorPlan, getTwilioConfig } from "../Utils/services";

export const getIsEfaxIntegrationAccessible = () => {
  return getIsAcceleratorPlan();
};

export const getIsRepeatMdIntegrationAccessible = () => {
  return getIsAcceleratorPlan();
};

export const getIsJoyaIntegrationAccessible = () => {
  return getIsAcceleratorPlan();
};

export const getIsInboxAccessible = () => {
  return getIsAcceleratorPlan() && getTwilioConfig();
};
